import { SnackToast as Toast } from "@/utils/snackToast";
import { truncate } from "lodash";
import {
  CATEGORY_CREATED,
  CATEGORY_UPDATED,
  DASHBOARD_VIEW_TYPES
} from "@/utils/enumerate";

import {
  getCapacities,
  getHierarchyCapacities,
  getCapacityControl,
  setCapacityPermission,
  setCapacityActive,
  getCapacitiesWithProcess,
  getAllProfiles,
  getProfile,
  getAllPermissions,
  getPermission,
  getAllPermissionsKeywords,
  editPermission,
  createProfile,
  updateProfile,
  deleteProfile,
  activeProfile,
  getProfileKeywords,
  getAllParts,
  getAllPartsDistinct,
  getAllPartAddresses,
  getPartAddress,
  getPartAddressBySeo,
  createPartAddress,
  updatePartAddress,
  deletePartAddress,
  getSearchSubjects,
  getSearchSubjectsById,
  getSearchPublicSubjects,
  getAllLegalReference,
  createLegalReference,
  getAllCategories,
  getAllIndexer,
  getCategoryById,
  postIndexer,
  createCategory,
  updateCategory,
  toggleCategory,
  deleteCategory,
  postUploadSubject,
  requestLinkDownloadSubject,
  deleteFileSubject,
  getFileTypeById,
  getFileTypes,
  getHolidays,
  getDashboardInfo,
  getDueDateList,
  getDueDateCapacityList,
  getDashboardCapacityInfo,
  getDashboardSubject,
  getDashboardCapacitySubject,
  getDashboardCapacities,
  getDashboardCapacityCapacities,
  getDashboardProductivity,
  getDashboardCapacityProductivity,
  getDashboardDueDate,
  getDashboardCapacityDueDate,
  getDashboardProcessAnalises,
  getDashboardCapacityProcessAnalises,
  getDashboardSignature,
  postFeedback,
  postFeedbackFile,
  postFeedbackMail,
  getSearchSupplier,
  getNews,
  getLaw,
  getDoc,
  getChangelog,
  getSuiteNumbers,
  getReportTypes,
  requestLinkDownloadUnity,
  getPartControl,
  setPartActive,
  getCapacityChildren
} from "@/services/api/ApiControls";
import { General } from "@/utils/constants";

import {
  ResponseGenericType,
  ResponsePaged,
  ResponseType
} from "@/store/types/types";
import { ActionContext } from "vuex/types";
import {
  ICapacityPublic,
  IFilterCapacity,
  ICapacityControl,
  ICapacityPermissions,
  ICapacityState,
  IPartAddressList,
  IPartAddress,
  IRequestPageProfile,
  IProfile,
  IRequestPagePermissions,
  IPermissionsProfile,
  IProfileKeyword,
  IProfileCreate,
  IRequestPageCategory,
  IToggleCategory,
  ISubjectExport,
  IUnityExport,
  IDashboardDate,
  IDashboardInfo,
  IDashboardRequestInfo,
  IDashboardProcessInfo,
  IDashboardSignatures,
  IFeedback,
  IFeedbackFile,
  IFeedbackFileRequest,
  INews,
  ILaw,
  IDoc,
  IChangelog,
  ISuiteNUmbers,
  IEmailFeedback,
  IReportTypes,
  IDashboardCapacitiesInfo,
  ILogo,
  IManageUnityFilter,
  ICapacityOrEntity,
  ICapacityStandardize,
  IDashboardProductivity,
  IDashboardDueDate,
  IDashboardProcessAnalise,
  IDashboardSubjects,
  IDashboardProcessSocket,
  IPartAddressItem,
  IPartControl,
  IPartState,
  ICapacityChildren,
  IRequestVersion
} from "@/store/types/control-types";
import { IPart } from "@/store/types/process-type";
import {
  ICategory,
  IIndex,
  ILegalReference,
  ISubject,
  ISubjectCategory
} from "@/store/types/category-types";
import { IFileType, IFileTypeParm } from "@/store/types/document-type";
import { IDownloadFileQueue } from "@/store/types/file-type";
import { showErrorMessage, showSuccessMessage } from "@/utils/messageUtility";
import { docTypeFilter } from "@/utils/endpointsFilter";
import { RootState } from "@/store/types/root";
import { capacityThreeAbbreviationFormatter } from "@/utils/capacityUtility";

const state = {
  capacities: [] as ICapacityPublic[],
  allCapacities: [] as ICapacityPublic[],
  allCapacitiesSearch: {} as Record<number, ICapacityPublic>,
  capacitiesWithParams: [] as ICapacityPublic[],
  hierarchyCapacities: [] as ICapacityPublic[],
  listPart: [] as IPartControl[],
  listCapacity: [] as ICapacityControl[],
  listCapacitiesWithProcess: [] as number[],
  listCapacityChildren: [] as ICapacityPublic[],
  parentCapacity: 0,
  parts: [] as IPart[],
  partsDistinct: [] as IPart[],
  partAddressList: [] as IPartAddressList[],
  capacityPartAddress: [] as IPartAddress[],
  capacityPartAddressSeo: [] as IPartAddress[],
  profilesList: [] as IProfile[],
  profilesListCount: 0,
  profilesByPart: [] as IProfile[],
  profile: {} as IProfile,
  subjects: [] as ISubject[],
  category: {} as ResponsePaged<ICategory>,
  legalReference: [] as ILegalReference[],
  indexer: [] as IIndex[],
  fileType: {} as IFileType,
  fileTypes: [] as IFileType[],
  holidays: [] as string[],
  dashboardInfo: {} as IDashboardInfo,
  dueDateList: [] as IDashboardProcessInfo[],
  dashboardSubject: {} as IDashboardSubjects,
  dashboardCapacities: {} as IDashboardCapacitiesInfo,
  dashboardProductivity: {} as IDashboardProductivity,
  dashboardDueDate: {} as IDashboardDueDate,
  dashboardSignature: {} as IDashboardSignatures,
  processAnalise: {} as IDashboardProcessAnalise,
  itens_page: [10, 25, 50, 100],
  news: [] as INews[],
  law: [] as ILaw[],
  doc: [] as IDoc[],
  law_gov: [] as ILaw[],
  viewSector: "INDIVIDUAL",
  lastVersion: {} as IChangelog,
  listHorizontalLogos: [] as ILogo[],
  listVerticalLogos: [] as ILogo[],
  versionList: [] as IChangelog[],
  versionCount: 0,
  suiteNumbers: {} as ISuiteNUmbers,
  permissionList: [] as IPermissionsProfile[],
  permissionCount: 0,
  profileKeywords: [] as IProfileKeyword[],
  permissionsKeywords: [] as string[],
  reportTypes: [] as IReportTypes[],
  manageUnityFilters: {} as IManageUnityFilter,
  isLoadingManageUnity: false
};

type State = typeof state;

const mutations = {
  capacitySuccess: (state: State, data: ICapacityPublic[]) => {
    state.capacities = data;
  },

  allCapacitySuccess: (state: State, data: ICapacityPublic[]) => {
    state.allCapacities = data;
    state.allCapacitiesSearch = data.reduce(
      (acc: Record<number, ICapacityPublic>, actual: ICapacityPublic) => {
        acc[actual.id] = actual;
        return acc;
      },
      {}
    );
  },

  capacityWithParamsSuccess: (state: State, data: ICapacityPublic[]) => {
    state.capacitiesWithParams = data;
  },

  hierarchyCapacitySuccess: (state: State, data: ICapacityPublic[]) => {
    state.hierarchyCapacities = data;
  },

  setPartControl: (state: State, data: IPartControl[]) => {
    state.listPart = data;
  },

  setCapacityControl: (state: State, data: ICapacityControl[]) => {
    state.listCapacity = data;
  },

  setCapacitiesWithProcess: (state: State, data: number[]) => {
    state.listCapacitiesWithProcess = data;
  },

  setCapacityChildren: (state: State, data: ICapacityChildren) => {
    state.listCapacityChildren = data.children || [];
    state.parentCapacity = data.parentCapacity || 0;
  },

  partRequestSuccess: (state: State, data: IPart[]) => {
    state.parts = data;
  },

  partDistinctRequestSuccess: (state: State, data: IPart[]) => {
    state.partsDistinct = data;
  },

  partAddressRequestSuccess: (state: State, data: IPartAddressList[]) => {
    state.partAddressList = data;
  },

  partAddressByIdRequestSuccess: (state: State, data: IPartAddress[]) => {
    state.capacityPartAddress = data;
  },

  partAddressSeoByIdRequestSuccess: (state: State, data: IPartAddress[]) => {
    state.capacityPartAddressSeo = data;
  },

  allProfilesSuccess: (state: State, data: ResponsePaged<IProfile>) => {
    state.profilesList = data.results;
    state.profilesListCount = data.count;
  },

  allProfilesByPartSuccess: (state: State, data: ResponsePaged<IProfile>) => {
    state.profilesByPart = data.results;
  },

  profileSuccess: (state: State, data: IProfile) => {
    state.profile = data;
  },

  subjectSuccess: (state: State, data: ISubject[]) => {
    state.subjects = data;
  },

  legalReferenceSuccess: (state: State, data: ILegalReference[]) => {
    state.legalReference = data;
  },

  addLegalReference: (state: State, data: ILegalReference) => {
    state.legalReference.push(data);
  },

  categorySuccess: (state: State, data: ResponsePaged<ICategory>) => {
    state.category = data;
  },

  categoryPush: (state: State, data: ICategory) => {
    state.category.results?.push(data);
  },

  categoryChange: (state: State, data: ICategory) => {
    if (state.category.results) {
      const changedItemIndex = state.category.results.findIndex(
        item => item.id === data.id
      );
      if (changedItemIndex !== -1)
        state.category.results[changedItemIndex] = data;
    }
  },

  fileTypeByIdSuccess: (state: State, data: IFileType) => {
    state.fileType = data;
  },

  fileTypesSuccess: (state: State, data: IFileType[]) => {
    data.sort((prev, next) => prev.type.localeCompare(next.type));
    state.fileTypes = data;
  },

  holidaysRequestSucess: (state: State, dates: string[]) => {
    state.holidays = dates;
  },

  setDashboardInfo: (state: State, data: IDashboardInfo) => {
    state.dashboardInfo = data;
  },

  setDashboardInfoSocket: (state: State, data: IDashboardInfo) => {
    let filteredData = {};
    if (state.viewSector === "SECTOR_AND_SUBORDINATES") {
      filteredData = {
        analising_count: data.analising_with_children_count,
        due_date_count: data.due_date_with_children_count,
        without_responsible: data.without_responsible_with_children,
        urgent_count: data.urgent_with_children_count
      };
    } else {
      const {
        analising_count,
        due_date_count,
        without_responsible,
        urgent_count
      } = data;
      filteredData = {
        analising_count,
        due_date_count,
        without_responsible,
        urgent_count
      };
    }
    state.dashboardInfo = filteredData;
  },

  setDueDateList: (state: State, list: IDashboardProcessInfo[]) => {
    state.dueDateList = list;
  },

  setDueDateListSocket: (state: State, list: IDashboardProcessSocket) => {
    let filteredData = [];
    if (state.viewSector === "SECTOR_AND_SUBORDINATES") {
      filteredData = list.process_data_with_children;
    } else {
      const { process_data } = list;
      filteredData = process_data;
    }
    state.dueDateList = filteredData;
  },

  setDashboardSubject: (state: State, list: IDashboardSubjects) => {
    state.dashboardSubject = list;
  },

  setDashboardSubjectSocket: (state: State, data: IDashboardSubjects) => {
    let filteredData = {};
    if (state.viewSector === "SECTOR_AND_SUBORDINATES") {
      filteredData = { subjects: data.subjects_with_capacity_children };
    } else {
      const { subjects } = data;
      filteredData = { subjects };
    }
    state.dashboardSubject = filteredData;
  },

  setDashboardCapacities: (state: State, list: IDashboardCapacitiesInfo) => {
    state.dashboardCapacities = list;
  },

  setDashboardCapacitiesSocket: (
    state: State,
    list: IDashboardCapacitiesInfo
  ) => {
    let filteredData = {};
    if (state.viewSector === "SECTOR_AND_SUBORDINATES") {
      filteredData = { capacities: list.capacities_with_children };
    } else {
      const { capacities } = list;
      filteredData = { capacities };
    }
    state.dashboardCapacities = filteredData;
  },

  setDashboardProductivity: (state: State, list: IDashboardProductivity) => {
    state.dashboardProductivity = list;
  },

  setDashboardProductivitySocket: (
    state: State,
    list: IDashboardProductivity
  ) => {
    let filteredData: IDashboardProductivity = {};
    if (state.viewSector === "SECTOR_AND_SUBORDINATES") {
      filteredData = {
        analysing_media: list.analysing_media_with_children,
        productivity: list.productivity_with_children,
        productivity_percentage: list.productivity_percentage_with_children
      };
    } else {
      const { analysing_media, productivity, productivity_percentage } = list;
      filteredData = { analysing_media, productivity, productivity_percentage };
    }
    state.dashboardProductivity = filteredData;
  },

  setDashboardDueDate: (state: State, list: IDashboardDueDate) => {
    state.dashboardDueDate = list;
  },

  setDashboardDueDateSocket: (state: State, list: IDashboardDueDate) => {
    let filteredData = {};
    if (state.viewSector === "SECTOR_AND_SUBORDINATES") {
      filteredData = { due_date_info: list.due_date_info_with_children };
    } else {
      const { due_date_info } = list;
      filteredData = { due_date_info };
    }
    state.dashboardDueDate = filteredData;
  },

  setDashboardProcessAnalises: (
    state: State,
    list: IDashboardProcessAnalise
  ) => {
    state.processAnalise = list;
  },

  setDashboardProcessAnalisesSocket: (
    state: State,
    list: IDashboardProcessAnalise
  ) => {
    let filteredData = {};
    if (state.viewSector === "SECTOR_AND_SUBORDINATES") {
      filteredData = { process_analises: list.process_analises_with_children };
    } else {
      const { process_analises } = list;
      filteredData = { process_analises };
    }
    state.processAnalise = filteredData;
  },

  setDashboardSignature: (state: State, list: IDashboardSignatures) => {
    state.dashboardSignature = list;
  },

  indexerSuccess: (state: State, list: IIndex[]) => {
    state.indexer = list;
  },

  setNews: (state: State, list: INews[]) => {
    state.news = list;
  },

  setLaw: (state: State, list: ILaw[]) => {
    state.law = list;
  },

  setDoc: (state: State, list: IDoc[]) => {
    state.doc = list;
  },

  setLawGov: (state: State, list: ILaw[]) => {
    state.law_gov = list;
  },

  setViewSector: (state: State, value: keyof typeof DASHBOARD_VIEW_TYPES) => {
    state.viewSector = DASHBOARD_VIEW_TYPES[value];
  },

  setVersion: (state: State, data: ResponsePaged<IChangelog>) => {
    state.versionList = data.results;
    state.versionCount = data.count;
  },

  setLastVersion: (state: State, data: ResponsePaged<IChangelog>) => {
    state.lastVersion = data.results?.[0];
  },

  setSuiteNumbers: (state: State, data: ISuiteNUmbers) => {
    state.suiteNumbers = data;
  },

  setProfileKeywords: (state: State, data: IProfileKeyword[]) => {
    state.profileKeywords = data;
  },

  setPermissionsKeywords: (state: State, data: IProfileKeyword) => {
    state.permissionsKeywords = data.keywords || [];
  },

  setPermissions: (state: State, data: ResponsePaged<IPermissionsProfile>) => {
    state.permissionList = data.results;
    state.permissionCount = data.count;
  },

  setListHorizontalLogos: (state: State, data: ILogo[]) => {
    state.listHorizontalLogos = data;
  },

  setListVerticalLogos: (state: State, data: ILogo[]) => {
    state.listVerticalLogos = data;
  },

  setReportTypes: (state: State, data: IReportTypes[]) => {
    state.reportTypes = data;
  },

  setManageUnityFilters: (state: State, data: IManageUnityFilter) => {
    state.manageUnityFilters = data;
  },

  updateCapacityPermission: (
    state: State,
    { capacityId, permissions }: ICapacityPermissions
  ) => {
    capacityId.forEach(actualId =>
      Object.assign(state.listCapacity[actualId], permissions)
    );
  },

  setIsLoadingManageUnity: (state: State, data: boolean) => {
    state.isLoadingManageUnity = data;
  }
};

const actions = {
  capacityRequest: async (
    { commit, dispatch }: ActionContext<State, RootState>,
    { part_id = null, capacity_id = null, all = false }: IFilterCapacity
  ) => {
    function capacityCommit(all: boolean, capacityList: ICapacityPublic[]) {
      if (all) commit("allCapacitySuccess", capacityList);
      commit(
        "capacitySuccess",
        capacityList.filter(({ active }) => active)
      );
    }

    const results = await dispatch("checkLocalData", {
      requestName: all ? "allCapacitySuccess" : "capacitySuccess",
      request: async () =>
        getCapacities({
          part_id,
          capacity_id,
          all
        })
    });

    if (results.kind === "ok" && results.data) {
      capacityCommit(all, results.data);
    } else showErrorMessage(results.message);
  },

  capacityWithParamsRequest: async (
    { commit }: ActionContext<State, RootState>,
    data: IFilterCapacity = { part_id: null, capacity_id: null }
  ) => {
    const results: ResponseType<ICapacityPublic[]> = await getCapacities(data);

    if (results.kind === "ok")
      commit("capacityWithParamsSuccess", results.data);
    else showErrorMessage(results.message);
  },

  capacityHierarchyRequest: async ({
    commit
  }: ActionContext<State, RootState>) => {
    const results: ResponseType<ICapacityPublic[]> = await getHierarchyCapacities();

    if (results.kind === "ok") commit("hierarchyCapacitySuccess", results.data);
    else showErrorMessage(results.message);
  },

  partControlRequest: async ({
    commit,
    getters
  }: ActionContext<State, RootState>) => {
    const results: ResponseType<IPartControl[]> = await getPartControl();

    if (results.kind === "ok" && results.data) {
      const partList: IPartControl[] = results.data.map(part => ({
        ...part,
        searchName: getters.getAbbreviationById(part)
      }));
      commit("setPartControl", partList);
    } else showErrorMessage(results.message);
  },

  capacityControlRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    partId: number
  ) => {
    const results: ResponseType<ICapacityControl[]> = await getCapacityControl(
      partId
    );

    if (results.kind === "ok") {
      const capacityOrEntityList: ICapacityControl[] = [];
      for (const index in results.data) {
        const capacityOrEntity = results.data[Number(index)];
        capacityOrEntityList[Number(index)] = {
          ...capacityOrEntity,
          searchName: getters.getAbbreviationById(capacityOrEntity)
        };
      }
      commit("setCapacityControl", capacityOrEntityList);
    } else showErrorMessage(results.message);
  },

  setCapacityPermissionRequest: async (
    { commit }: ActionContext<State, RootState>,
    { capacityId, permissions, update = false }: ICapacityPermissions
  ) => {
    const results: ResponseType<ICapacityPermissions> = await setCapacityPermission(
      {
        capacityId,
        permissions
      }
    );

    if (results.kind === "ok")
      update && commit("updateCapacityPermission", { capacityId, permissions });
    else showErrorMessage(results.message);
  },

  changePartState: async (
    _: ActionContext<State, RootState>,
    list: IPartState[]
  ) => {
    const results: ResponseType<IPartState[]> = await setPartActive(list);

    if (results.kind !== "ok") showErrorMessage(results.message);
  },

  changeCapacityState: async (
    _: ActionContext<State, RootState>,
    list: ICapacityState[]
  ) => {
    const results: ResponseType<ICapacityState[]> = await setCapacityActive(
      list
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
  },

  requestCapacitiesWithProcess: async ({
    commit
  }: ActionContext<State, RootState>) => {
    const results: ResponseType<number[]> = await getCapacitiesWithProcess();

    if (results.kind === "ok") commit("setCapacitiesWithProcess", results.data);
    else showErrorMessage(results.message);
  },

  requestCapacityChildren: async (
    { commit, getters }: ActionContext<State, RootState>,
    capacityId: number
  ) => {
    const results: ResponseType<ICapacityChildren> = await getCapacityChildren(
      capacityId
    );

    if (results.kind === "ok" && results.data)
      commit("setCapacityChildren", {
        parentCapacity: capacityId,
        children: results.data.capacities?.map(id => ({
          id,
          ...getters.getCapacityById(id)
        }))
      });
    else showErrorMessage(results.message);
  },

  partRequest: async ({
    dispatch,
    commit,
    getters
  }: ActionContext<State, RootState>) => {
    function partCommit(parts: IPart[], cacheDate: string) {
      commit("partRequestSuccess", parts);
      commit("setPartsCache", { date: cacheDate, data: parts });
    }
    const now = new Date().toLocaleDateString("pt-BR");

    if (getters.getPartsCache.date === now) {
      commit("partRequestSuccess", getters.getPartsCache.data);
      return;
    }

    const results = await dispatch("checkLocalData", {
      requestName: "partSuccess",
      request: async () => getAllParts()
    });

    if (results.kind === "ok" && results.data) {
      partCommit(results.data, now);
    } else showErrorMessage(results.message);
  },

  partDistinctRequest: async ({ commit }: ActionContext<State, RootState>) => {
    const results: ResponseType<IPart[]> = await getAllPartsDistinct();

    if (results.kind === "ok")
      commit("partDistinctRequestSuccess", results.data);
    else showErrorMessage(results.message);
  },

  partAddressRequest: async ({
    commit,
    getters
  }: ActionContext<State, RootState>) => {
    const results: ResponseType<IPartAddressList[]> = await getAllPartAddresses();

    if (results.kind === "ok")
      commit(
        "partAddressRequestSuccess",
        results.data
          ?.map(address => ({
            part: getters.getPartsById(address.part_id),
            capacity: getters.getCapacityById(address.capacity_id),
            ...address
          }))
          .sort((first: IPartAddressItem, second: IPartAddressItem) =>
            (
              first.capacity?.description ||
              first.part?.name ||
              ""
            ).localeCompare(
              second.capacity?.description || second.part?.name || ""
            )
          )
      );
    else showErrorMessage(results.message);
  },

  partAddressByIdRequest: async (
    { commit }: ActionContext<State, RootState>,
    partId: number
  ) => {
    const results: ResponseType<IPartAddress[]> = await getPartAddress(partId);
    if (results.kind === "ok")
      commit("partAddressByIdRequestSuccess", results.data);
    else showErrorMessage(results.message);
  },

  partAddressSeoByIdRequest: async (
    { commit }: ActionContext<State, RootState>,
    partId: number
  ) => {
    const results: ResponseType<IPartAddress[]> = await getPartAddressBySeo(
      partId
    );

    if (results.kind === "ok")
      commit("partAddressSeoByIdRequestSuccess", results.data);
    else showErrorMessage(results.message);
  },

  createPartAddress: async (
    _: ActionContext<State, RootState>,
    partData: IPartAddress
  ) => {
    const results: ResponseGenericType = await createPartAddress(partData);
    const status = results.kind === "ok";

    if (!status) showErrorMessage(results.message);

    return status;
  },

  updatePartAddress: async (
    _: ActionContext<State, RootState>,
    { partId, partData }: { partId: number; partData: IPartAddress }
  ) => {
    const results: ResponseGenericType = await updatePartAddress(
      partId,
      partData
    );
    const status = results.kind === "ok";

    if (!status) showErrorMessage(results.message);

    return status;
  },

  deletePartAddress: async (
    _: ActionContext<State, RootState>,
    partId: number
  ) => {
    const results: ResponseGenericType = await deletePartAddress(partId);

    if (results.kind !== "ok") showErrorMessage(results.message);
  },

  profileRequest: async (
    { commit }: ActionContext<State, RootState>,
    {
      page = 1,
      paginator_count = 999,
      search = "",
      permissions,
      profile_assigner,
      simple = false,
      list = false
    }: IRequestPageProfile
  ) => {
    const results: ResponseType<ResponsePaged<IProfile>> = await getAllProfiles(
      {
        page,
        paginator_count,
        search,
        permissions,
        profile_assigner,
        simple,
        list
      }
    );

    if (results.kind === "ok") commit("allProfilesSuccess", results.data);
    else showErrorMessage(results.message);
  },

  profileRequestByPart: async (
    { commit }: ActionContext<State, RootState>,
    {
      page = 1,
      paginator_count = 999,
      search = "",
      permissions,
      part,
      simple = false,
      list = false
    }: IRequestPageProfile
  ) => {
    const results: ResponseType<ResponsePaged<IProfile>> = await getAllProfiles(
      {
        page,
        paginator_count,
        search,
        permissions,
        part,
        simple,
        list
      }
    );

    if (results.kind === "ok") commit("allProfilesByPartSuccess", results.data);
    else showErrorMessage(results.message);
  },

  profileByIdRequest: async (
    { commit }: ActionContext<State, RootState>,
    profileId: number
  ) => {
    const results: ResponseType<IProfile> = await getProfile(profileId);

    if (results.kind === "ok") commit("profileSuccess", results.data);
    else showErrorMessage(results.message);
  },

  getAllPermissionsRequest: async (
    { commit }: ActionContext<State, RootState>,
    {
      page = 1,
      order_by,
      paginator_count = 999,
      search_text,
      simple = false
    }: IRequestPagePermissions
  ) => {
    const results: ResponseType<ResponsePaged<
      IPermissionsProfile
    >> = await getAllPermissions({
      page,
      order_by,
      paginator_count,
      search_text,
      simple
    });

    if (results.kind === "ok") commit("setPermissions", results.data);
    else showErrorMessage(results.message);
  },

  getAllKeywordRequest: async ({ commit }: ActionContext<State, RootState>) => {
    const results: ResponseType<IProfileKeyword> = await getAllPermissionsKeywords();

    if (results.kind === "ok") commit("setPermissionsKeywords", results.data);
    else showErrorMessage(results.message);
  },

  getPermissionRequest: async (
    _: ActionContext<State, RootState>,
    permissionId: number
  ) => {
    const results: ResponseType<IPermissionsProfile> = await getPermission(
      permissionId
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results.data;
  },

  editPermissionRequest: async (
    _: ActionContext<State, RootState>,
    { permissionId, data }: { permissionId: number; data: IPermissionsProfile }
  ) => {
    const results: ResponseType<IPermissionsProfile> = await editPermission(
      permissionId,
      data
    );

    if (results.kind === "ok")
      showSuccessMessage({ message: General.MESSAGES.PERMISSION_SUCCESS });
    else showErrorMessage(results.message);
    return results.kind === "ok";
  },

  createProfileRequest: async (
    _: ActionContext<State, RootState>,
    {
      name,
      parts,
      all_parts,
      permissions,
      keywords,
      profiles_can_assign
    }: IProfileCreate
  ) => {
    const results: ResponseType<IProfileCreate> = await createProfile({
      name,
      parts,
      all_parts,
      permissions,
      keywords,
      profiles_can_assign
    });
    const status = results.kind === "ok";

    if (status) return status;
    showErrorMessage(results.message);
  },

  updateProfileRequest: async (
    _: ActionContext<State, RootState>,
    {
      name,
      parts,
      all_parts,
      permissions,
      keywords,
      profile_x_permission,
      profiles_can_assign,
      profileId
    }: IProfileCreate
  ) => {
    const results: ResponseType<IProfileCreate> = await updateProfile({
      name,
      parts,
      all_parts,
      permissions,
      keywords,
      profile_x_permission,
      profiles_can_assign,
      profileId
    });
    const status = results.kind === "ok";

    if (status) return status;
    showErrorMessage(results.message);
  },

  deleteProfileRequest: async (
    _: ActionContext<State, RootState>,
    profileId: number
  ) => {
    const results: ResponseGenericType = await deleteProfile(profileId);
    const status = results.kind === "ok";

    if (status) return status;
    showErrorMessage(results.message);
  },

  activeProfileRequest: async (
    _: ActionContext<State, RootState>,
    { profileId, active }: { profileId: number; active: boolean }
  ) => {
    const results: ResponseType<IProfile> = await activeProfile(
      profileId,
      active
    );
    const status = results.kind === "ok";

    if (status) return status;
    showErrorMessage(results.message);
  },

  profileKeywordsRequest: async (
    { commit }: ActionContext<State, RootState>,
    keyword: string
  ) => {
    const results: ResponseType<IProfileKeyword[]> = await getProfileKeywords(
      keyword
    );

    if (results.kind === "ok") commit("setProfileKeywords", results.data);
    else showErrorMessage(results.message);
  },

  subjectRequest: async (
    { commit }: ActionContext<State, RootState>,
    search_text: string
  ) => {
    const results: ResponseType<ISubject[]> = await getSearchSubjects(
      search_text
    );

    if (results.kind === "ok") commit("subjectSuccess", results.data);
    else showErrorMessage(results.message);
  },

  subjectPublicRequest: async (
    { commit }: ActionContext<State, RootState>,
    search_text: string
  ) => {
    const results: ResponseType<ISubject[]> = await getSearchPublicSubjects(
      search_text
    );

    if (results.kind === "ok") commit("subjectSuccess", results.data);
    else showErrorMessage(results.message);
  },

  subjectRequestById: async (
    { commit }: ActionContext<State, RootState>,
    subjectId: string
  ) => {
    const results: ResponseType<ISubject> = await getSearchSubjectsById(
      subjectId
    );

    if (results.kind === "ok") commit("subjectSuccess", [results.data]);
    else showErrorMessage(results.message);
  },

  legalReferenceRequest: async ({
    commit
  }: ActionContext<State, RootState>) => {
    const results: ResponseType<ILegalReference[]> = await getAllLegalReference();

    if (results.kind === "ok") commit("legalReferenceSuccess", results.data);
    else showErrorMessage(results.message);
  },

  legalReferenceRequestIfNotExist: async ({
    commit,
    state
  }: ActionContext<State, RootState>) => {
    if (state.legalReference.length > 0) return;
    const results: ResponseType<ILegalReference[]> = await getAllLegalReference();

    if (results.kind === "ok") commit("legalReferenceSuccess", results.data);
    else showErrorMessage(results.message);
  },

  legalReferenceCreate: async (
    { commit }: ActionContext<State, RootState>,
    legalReference: ILegalReference
  ) => {
    const results: ResponseType<ILegalReference> = await createLegalReference(
        legalReference
      ),
      status = results.kind === "ok";

    if (!status) showErrorMessage(results.message);
    else commit("addLegalReference", results.data);
    return status ? results.data : false;
  },

  createCategory: async (
    { commit }: ActionContext<State, RootState>,
    { category, createSubject }: { category: ICategory; createSubject: boolean }
  ) => {
    const results: ResponseType<ICategory> = await createCategory(
        category,
        createSubject
      ),
      status = results.kind === "ok";

    if (status) {
      commit("categoryPush", results.data);
      showSuccessMessage({
        message:
          CATEGORY_CREATED[
            String(category.level) as keyof typeof CATEGORY_CREATED
          ]
      });
    } else showErrorMessage(results.message);
    return { status, result: results.data };
  },

  deleteCategory: async (
    _: ActionContext<State, RootState>,
    categoryId: string
  ) => {
    const results: ResponseGenericType = await deleteCategory(categoryId);

    if (results.kind !== "ok") showErrorMessage(results.message);
  },

  indexerRequest: async ({ commit }: ActionContext<State, RootState>) => {
    const results: ResponseType<IIndex[]> = await getAllIndexer();

    if (results.kind === "ok") commit("indexerSuccess", results.data);
    else showErrorMessage(results.message);
  },

  indexerCreate: async (_: ActionContext<State, RootState>, name: string) => {
    const results: ResponseType<IIndex> = await postIndexer(name);

    if (results.kind !== "ok") showErrorMessage(results.message);
  },

  categoryRequest: async (
    { commit }: ActionContext<State, RootState>,
    config: IRequestPageCategory
  ) => {
    const results: ResponseType<ResponsePaged<
      ISubjectCategory
    >> = await getAllCategories(config);

    if (results.kind === "ok") commit("categorySuccess", results.data);
    else showErrorMessage(results.message);
  },

  categoryRequestByLevel: async (
    _: ActionContext<State, RootState>,
    {
      page = 1,
      paginator_count = 10,
      search = "",
      levels,
      autocomplete = false,
      categories
    }: IRequestPageCategory
  ) => {
    const results: ResponseType<ResponsePaged<
      ICategory
    >> = await getAllCategories({
      page,
      paginator_count,
      search,
      levels,
      autocomplete,
      categories
    });

    if (results.kind === "ok") return results.data?.results;
    showErrorMessage(results.message);
  },

  categoryRequestById: async (
    _: ActionContext<State, RootState>,
    categoryId: string
  ) => {
    const results: ResponseType<ICategory> = await getCategoryById(categoryId);

    if (results.kind === "ok") return results.data;
    showErrorMessage(results.message);
  },

  updateCategory: async (
    { commit }: ActionContext<State, RootState>,
    {
      id,
      category,
      createSubject
    }: { id: string; category: ICategory; createSubject: boolean }
  ) => {
    const results: ResponseType<ICategory> = await updateCategory(
        category,
        id,
        createSubject
      ),
      status = results.kind === "ok";

    if (status) {
      commit("categoryChange", results.data);
      showSuccessMessage({
        message:
          CATEGORY_UPDATED[
            String(category.level) as keyof typeof CATEGORY_UPDATED
          ]
      });
    } else showErrorMessage(results.message);
    return { status, result: results.data };
  },

  toggleCategory: async (
    _: ActionContext<State, RootState>,
    { id, category }: { id: string; category: IToggleCategory }
  ) => {
    const results: ResponseGenericType = await toggleCategory(category, id),
      status = results.kind === "ok";

    if (!status) showErrorMessage(results.message);
    return { status, result: results.data };
  },

  updloadSubject: async (
    { commit }: ActionContext<State, RootState>,
    file: Blob
  ) => {
    const formData = new FormData();
    formData.append("file", file);
    const results: ResponseType<ResponsePaged<
      ISubject
    >> = await postUploadSubject(formData);

    if (results.kind === "ok" && results.data?.results?.length)
      commit("categorySuccess", results.data);
    return results;
  },

  requestLinkDownloadSubject: async (
    { dispatch }: ActionContext<State, RootState>,
    filters: ISubjectExport
  ) => {
    showSuccessMessage({ message: General.TEXTS.EXPORTATION_STARTED });
    const results: ResponseType<IDownloadFileQueue> = await requestLinkDownloadSubject(
      filters
    );
    if (results.kind !== "ok")
      dispatch("startDownload", { file_index: filters.file_index });
    return results;
  },

  requestLinkDownloadUnity: async (
    { dispatch }: ActionContext<State, RootState>,
    filters: IUnityExport
  ) => {
    showSuccessMessage({ message: General.TEXTS.EXPORTATION_STARTED });
    const results: ResponseType<IDownloadFileQueue> = await requestLinkDownloadUnity(
      filters
    );
    if (results.kind === "ok") dispatch("startDownload", results.data);
    else dispatch("startDownload", { file_index: filters.file_index });
    return results;
  },

  removeFileSubject: async (
    _: ActionContext<State, RootState>,
    link: string
  ) => {
    const results: ResponseGenericType = await deleteFileSubject(link);
    if (results.kind !== "ok") showErrorMessage(results.message);
    return results;
  },

  fileTypeByIdRequest: async (
    { commit }: ActionContext<State, RootState>,
    typeId: string
  ) => {
    const results: ResponseType<IFileType> = await getFileTypeById(typeId);

    if (results.kind === "ok") commit("fileTypeByIdSuccess", results.data);
    else showErrorMessage(results.message);
  },

  fileTypesRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    {
      state = true,
      to_publish = false,
      excludeRequestTypes = false
    }: IFileTypeParm
  ) => {
    const now = new Date().toLocaleDateString("pt-BR");
    const filters = {
      state: state ? General.ACTIVE_MASC : General.INACTIVE_MASC,
      to_publish,
      excludeRequestTypes
    };
    if (getters.getFileTypesCache.date === now) {
      const filterData = docTypeFilter(getters.getFileTypesCache.data, filters);
      commit("fileTypesSuccess", filterData);
      return;
    }
    const results: ResponseType<IFileType[]> = await getFileTypes();

    if (results.kind === "ok") {
      const list = results.data || [];
      const filterData = docTypeFilter(list, filters);
      commit("fileTypesSuccess", filterData);
      commit("setFileTypesCache", { date: now, data: list });
    } else showErrorMessage(results.message);
  },

  holidaysRequest: async ({
    getters,
    commit,
    dispatch
  }: ActionContext<State, RootState>) => {
    function holidaysCommit(dates: string[], cacheDate: string) {
      commit("holidaysRequestSucess", dates);
      commit("setHolidaysCache", { date: cacheDate, data: dates });
    }

    const now = new Date().toLocaleDateString("pt-BR", {
      month: "numeric",
      year: "numeric"
    });

    if (getters.getHolidaysCache.date === now) {
      commit("holidaysRequestSucess", getters.getHolidaysCache.data);
      return;
    }

    const results = await dispatch("checkLocalData", {
      requestName: "holidays",
      request: async () => getHolidays()
    });

    if (results.kind === "ok" && results.data) {
      holidaysCommit(results.data.dates, now);
    } else showErrorMessage(results.message);
  },

  dashboardRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardInfo> = await getDashboardInfo(date);

    if (results.kind === "ok") commit("setDashboardInfo", results.data);
    else showErrorMessage(results.message);
  },

  dueDateProcessRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardDate
  ) => {
    const results: ResponseType<IDashboardProcessInfo[]> = await getDueDateList(
      date
    );

    if (results.kind === "ok") commit("setDueDateList", results.data);
    else showErrorMessage(results.message);
  },

  dashboardCapacityRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardInfo> = await getDashboardCapacityInfo(
      date
    );

    if (results.kind === "ok") commit("setDashboardInfo", results.data);
    else showErrorMessage(results.message);
  },

  dueDateProcessCapacityRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    date: IDashboardDate
  ) => {
    const results: ResponseType<IDashboardProcessInfo[]> = await getDueDateCapacityList(
      date
    );

    if (results.kind === "ok")
      commit(
        "setDueDateList",
        results.data?.map(process => ({
          ...process,
          origin: getters.getCapacityById(process.origin)
        }))
      );
    else showErrorMessage(results.message);
  },

  dashboardDueDateRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardDueDate> = await getDashboardDueDate(
      date
    );

    if (results.kind === "ok") commit("setDashboardDueDate", results.data);
    else showErrorMessage(results.message);
  },

  dashboardDueDateCapacityRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardDueDate> = await getDashboardCapacityDueDate(
      date
    );

    if (results.kind === "ok") commit("setDashboardDueDate", results.data);
    else showErrorMessage(results.message);
  },

  dashboardSubjectRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardSubjects> = await getDashboardSubject(
      date
    );

    if (results.kind === "ok") commit("setDashboardSubject", results.data);
    else showErrorMessage(results.message);
  },

  dashboardSubjectCapacityRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardSubjects> = await getDashboardCapacitySubject(
      date
    );

    if (results.kind === "ok") commit("setDashboardSubject", results.data);
    else showErrorMessage(results.message);
  },

  dashboardCapacitiesRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardCapacitiesInfo> = await getDashboardCapacities(
      date
    );

    if (results.kind === "ok")
      commit("setDashboardCapacities", {
        ...results.data,
        capacities: results.data?.capacities?.map(item => ({
          ...item,
          capacity: getters.getCapacityById(item.capacity)
        }))
      });
    else showErrorMessage(results.message);
  },

  dashboardCapacitiesCapacityRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardCapacitiesInfo> = await getDashboardCapacityCapacities(
      date
    );

    if (results.kind === "ok")
      commit("setDashboardCapacities", {
        ...results.data,
        capacities: results.data?.capacities?.map(item => ({
          ...item,
          capacity: getters.getCapacityById(item.capacity)
        }))
      });
    else showErrorMessage(results.message);
  },

  dashboardProcessAnalisesCapacityRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardProcessAnalise> = await getDashboardCapacityProcessAnalises(
      date
    );

    if (results.kind === "ok")
      commit("setDashboardProcessAnalises", results.data);
    else showErrorMessage(results.message);
  },

  dashboardProcessAnalisesRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardProcessAnalise> = await getDashboardProcessAnalises(
      date
    );

    if (results.kind === "ok")
      commit("setDashboardProcessAnalises", results.data);
    else showErrorMessage(results.message);
  },

  dashboardProductivityRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardProductivity> = await getDashboardProductivity(
      date
    );

    if (results.kind === "ok") commit("setDashboardProductivity", results.data);
    else showErrorMessage(results.message);
  },

  dashboardProductivityCapacityRequest: async (
    { commit }: ActionContext<State, RootState>,
    date: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardProductivity> = await getDashboardCapacityProductivity(
      date
    );

    if (results.kind === "ok") commit("setDashboardProductivity", results.data);
    else showErrorMessage(results.message);
  },

  dashboardSignatureRequest: async (
    { commit }: ActionContext<State, RootState>,
    { sector = false, with_children = false }: IDashboardRequestInfo
  ) => {
    const results: ResponseType<IDashboardSignatures> = await getDashboardSignature(
      { sector, with_children }
    );

    if (results.kind === "ok") commit("setDashboardSignature", results.data);
    else showErrorMessage(results.message);
  },

  sendFeedback: async (
    _: ActionContext<State, RootState>,
    feedback: IFeedback
  ) => {
    const results: ResponseType<IFeedback> = await postFeedback(feedback);

    if (results.kind === "ok") {
      return results.data;
    } else showErrorMessage(results.message);
  },

  sendFeedbackFile: async (
    _: ActionContext<State, RootState>,
    feedbackFile: IFeedbackFileRequest
  ) => {
    const formData = new FormData();
    formData.append("feedback_id", String(feedbackFile.feedback));
    formData.append("file", feedbackFile.file);

    const results: ResponseType<IFeedbackFile> = await postFeedbackFile(
      formData
    );

    const resultRequest = results.kind === "ok";

    if (!resultRequest) showErrorMessage(results.message);
    return resultRequest;
  },

  supplierRequest: async (
    _: ActionContext<State, RootState>,
    { name, cnpj }: { name: string; cnpj: string }
  ) => {
    const results: ResponseGenericType = await getSearchSupplier({
      name,
      cnpj
    });

    return results.kind === "ok" && results.data;
  },

  getNewsList: async ({ commit }: ActionContext<State, RootState>) => {
    const results: ResponseType<INews[]> = await getNews();

    if (results.kind === "ok") commit("setNews", results.data);
    else showErrorMessage(results.message);
  },

  getLawList: async ({ commit }: ActionContext<State, RootState>) => {
    const results: ResponseType<ILaw[]> = await getLaw();

    if (results.kind === "ok") commit("setLaw", results.data);
    else showErrorMessage(results.message);
  },

  getDocList: async ({ commit }: ActionContext<State, RootState>) => {
    const results: ResponseType<IDoc[]> = await getDoc();

    if (results.kind === "ok") commit("setDoc", results.data);
    else showErrorMessage(results.message);
  },

  requestVersion: async (
    { commit, dispatch }: ActionContext<State, RootState>,
    { paginator_count = 1, page = 1, last = false }: IRequestVersion
  ) => {
    function commitVersion(last: boolean, version: ResponsePaged<IChangelog>) {
      commit(last ? "setLastVersion" : "setVersion", version);
    }

    const results = await dispatch("checkLocalData", {
      requestName: last ? "lastVersion" : "allVersion",
      request: async () => getChangelog({ paginator_count, page })
    });

    if (results.kind === "ok" && results.data)
      commitVersion(last, results.data);
    else showErrorMessage(results.message);
  },

  requestSuiteNumbers: async ({
    commit,
    getters
  }: ActionContext<State, RootState>) => {
    const now = new Date().toLocaleDateString("pt-BR");

    if (getters.getSuiteNumbersCache.date === now) {
      commit("setSuiteNumbers", getters.getSuiteNumbersCache.data);
      return;
    }

    const results: ResponseType<ISuiteNUmbers> = await getSuiteNumbers();

    if (results.kind === "ok") {
      commit("setSuiteNumbers", results.data);
      commit("setSuiteNumbersCache", { date: now, data: results.data });
    } else showErrorMessage(results.message);
  },

  getLawGovList: async ({ commit }: ActionContext<State, RootState>) => {
    const results: ResponseType<ILaw[]> = await getLaw(true);

    if (results.kind === "ok") commit("setLawGov", results.data);
    else showErrorMessage(results.message);
  },

  sendFeedbackMail: async (
    _: ActionContext<State, RootState>,
    { feedback_id, send_me }: IEmailFeedback
  ) => {
    const results: ResponseGenericType = await postFeedbackMail({
      feedback_id,
      send_me
    });

    if (results.kind === "ok") {
      showSuccessMessage({ message: General.MESSAGES.FEEDBACK_SUCCESS });
      return results.data;
    } else showErrorMessage(results.message);
  },

  requestReportTypes: async ({ commit }: ActionContext<State, RootState>) => {
    const results: ResponseType<IReportTypes[]> = await getReportTypes();

    if (results.kind === "ok") commit("setReportTypes", results.data);
    else showErrorMessage(results.message);
  },

  updateCacheAction: async (
    _: ActionContext<State, RootState>,
    {
      reload = true,
      clearCache = false,
      serviceWorkerUpdate = true,
      serviceWorkerUnregister = false
    }
  ) => {
    if (clearCache) {
      await caches.keys().then(keys => {
        return Promise.allSettled(keys.map(key => caches.delete(key)));
      });
    }
    if (serviceWorkerUpdate || serviceWorkerUnregister) {
      await navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          serviceWorkerUpdate &&
            registration.waiting?.postMessage({ type: "SKIP_WAITING" });
          serviceWorkerUnregister && registration.unregister();
        });
      });
    }
    reload && window.location.reload();
  },

  openInfoCacheUpdate: ({ dispatch }: ActionContext<State, RootState>) => {
    Toast.open({
      message: General.TEXTS.EXISTS_UPDATE,
      position: "is-top",
      type: "is-info",
      actionText: General.RELOAD,
      duration: 1e3 * 60 * 60 * 24, //24 hrs em milisegundos
      callback: () => {
        dispatch("updateCacheAction", {
          reload: true,
          serviceWorkerUpdate: true
        });
      }
    });
  }
};

interface Getters {
  capacityStandardize: (_capacity: ICapacityPublic) => ICapacityStandardize;
  getCapacityById: (_id: number) => ICapacityPublic;
  getAbbreviationById: (_capacity: ICapacityControl) => string;
}

const getters = {
  getAllCapacities: (state: State) => state.allCapacities,

  getCapacities: (state: State) => state.capacities,

  getCapacitiesFiltered: (state: State, getters: Getters) => (
    filter?: string,
    organName?: string | null
  ) => {
    let finalList = organName
      ? state.capacities.filter(
          capacity =>
            capacity.active && organName.includes(capacity.entity.name)
        )
      : state.capacities.filter(capacity => capacity.active);

    if (typeof filter === "string" && filter.length) {
      const filterSpliter = filter.toLowerCase().split(" ");
      filterSpliter.forEach(filter => {
        const newArray: ICapacityPublic[] = [];
        finalList.forEach(capacity => {
          if (
            `${capacity.description} ${capacity.entity.abbreviation} ${
              capacity.abbreviation.includes("/")
                ? capacity.abbreviation.split("/")[1]
                : capacity.abbreviation
            }`
              .toLowerCase()
              .includes(filter)
          )
            newArray.push(capacity);
          finalList = newArray;
        });
      });
    }
    return finalList.map(getters.capacityStandardize);
  },

  getCapacitiesWithParamsFiltered: (state: State, getters: Getters) => (
    filter?: string,
    organName?: string
  ) => {
    let finalList = organName
      ? state.capacitiesWithParams.filter(
          capacity =>
            capacity.active && organName.includes(capacity.entity.name)
        )
      : state.capacitiesWithParams.filter(capacity => capacity.active);

    if (typeof filter === "string" && filter.length) {
      const filterSpliter = filter.toLowerCase().split(" ");
      filterSpliter.forEach(filter => {
        const newArray: ICapacityPublic[] = [];
        finalList.forEach(capacity => {
          if (
            `${capacity.description} ${capacity.entity.abbreviation} ${
              capacity.abbreviation.includes("/")
                ? capacity.abbreviation.split("/")[1]
                : capacity.abbreviation
            }`
              .toLowerCase()
              .includes(filter)
          )
            newArray.push(capacity);
          finalList = newArray;
        });
      });
    }
    return finalList.map(getters.capacityStandardize);
  },

  getPartAddressBySeo: (state: State) => state.capacityPartAddressSeo,

  getAbbreviationById: (_: State, getters: Getters) => (
    capacityOrEntity: ICapacityOrEntity
  ) => {
    const capacity = getters.getCapacityById(capacityOrEntity.id);
    const capacityAbbreviation = capacity?.abbreviation
      ? ` - ${capacity.abbreviation}`
      : "";
    return capacityOrEntity.description
      ? `${truncate(capacityOrEntity.description, {
          length: 100
        })}${capacityAbbreviation}`
      : `${capacityOrEntity.name} - ${capacityOrEntity.abbreviation}`;
  },

  getCapacityFormatted: (_: State, getters: Getters) => (
    capacityId: string | number
  ) => {
    const capacity = getters.getCapacityById(Number(capacityId));
    if (!capacity) return "";
    return `${capacity.entity.abbreviation}/${
      capacity.abbreviation.includes("/")
        ? capacity.abbreviation.split("/")[1]
        : capacity.abbreviation
    }`;
  },

  getCapacityById: (state: State) => (_id: number) =>
    state.allCapacitiesSearch[Number(_id)],

  getHierarchyPart: (state: State) =>
    Object.values(
      state.hierarchyCapacities
        .filter(hierarchy => hierarchy.entity.active)
        .reduce(
          (acc, capacity) =>
            Object.assign(acc, {
              [capacity.entity.id]: {
                ...capacity.entity,
                part_description: `${capacity.entity.name} - ${capacity.entity.abbreviation}`
              }
            }),
          {}
        )
    ),

  getHierarchyCapacitiesFiltered: (state: State, getters: Getters) => (
    filter?: string
  ) => {
    let finalList = state.hierarchyCapacities.filter(
      hierarchy => hierarchy.active
    );
    if (typeof filter === "string" && filter.length) {
      const filterSpliter = filter.toLowerCase().split(" ");
      filterSpliter.forEach(filter => {
        const newArray: ICapacityPublic[] = [];
        finalList.forEach(capacity => {
          if (
            `${capacity.description} ${capacity.entity.abbreviation} ${
              capacity.abbreviation.includes("/")
                ? capacity.abbreviation.split("/")[1]
                : capacity.abbreviation
            }`
              .toLowerCase()
              .includes(filter)
          )
            newArray.push(capacity);
          finalList = newArray;
        });
      });
    }

    finalList.sort((firstCapacity, secondCapacity) => {
      if (firstCapacity?.core_protocol || secondCapacity?.core_protocol)
        return (
          Number(secondCapacity?.core_protocol) -
          Number(firstCapacity?.core_protocol)
        );
      return (
        Number(secondCapacity?.external_receptor) -
        Number(firstCapacity?.external_receptor)
      );
    });

    return finalList.map(getters.capacityStandardize);
  },

  getParts: (state: State) => state.parts,

  getPartsById: (state: State) => (partId: number) =>
    state.parts.find(part => part.id === partId),

  getFilteredParts: (state: State) => (filter = "") =>
    state.parts
      .filter(part =>
        `${part.name} ${part.abbreviation}`
          .toLowerCase()
          .includes(filter.toLowerCase())
      )
      .map(part => ({
        ...part,
        showName: `${part.abbreviation} - ${part.name}`
      })),
  getDocumentFiltered: (state: State) => (filter = "") =>
    state.fileTypes.filter(file => RegExp(filter, "i").test(file.type)),

  getPartsDistinct: (state: State) => state.partsDistinct,

  getFilteredPartsDistinct: (state: State) => (filter = "") =>
    state.partsDistinct.filter(part =>
      `${part.name} ${part.abbreviation}`
        .toLowerCase()
        .includes(filter.toLowerCase())
    ),

  getpartAddressList: (state: State) => state.partAddressList,

  getCurrentPartAddress: (state: State) => state.capacityPartAddress,

  getFilteredLegalReferenceById: (state: State) => (id: number) => {
    return state.legalReference.find(legalRef => legalRef.id === id);
  },
  getFilteredLegalReference: (state: State) => (filter: string, trunc = 30) =>
    state.legalReference
      .filter(legalRef =>
        legalRef.description.toLowerCase().includes(filter.toLowerCase())
      )
      .map(legalRef => ({
        ...legalRef,
        description_trunc: truncate(
          legalRef.description.replace(/ \(.+/g, ""),
          { length: trunc }
        )
      })),
  getProfile: (state: State) => state.profile,

  getProfiles: (state: State) => ({
    results: state.profilesList,
    count: state.profilesListCount
  }),

  getProfilesByName: (state: State) => (name: string) =>
    state.profilesList.filter(profile =>
      profile.name.toLowerCase().includes(name.toLowerCase())
    ),

  getProfilesByPart: (state: State) => state.profilesByPart,

  getSubjects: (state: State) =>
    state.subjects.map(option => ({
      ...option,
      completeName: option.name
        .toLowerCase()
        .split(" - ")
        .map(partName => `${partName[0].toUpperCase()}${partName.slice(1)}`)
        .join(" - ")
    })),

  getCategory: (state: State) => state.category,

  getCategoryByLevel: (state: State) => (level: number) =>
    state.category.results.filter(category => category.level === level),

  getSubjectById: (state: State) => (id: number) =>
    state.subjects.find(subject => id === subject.id, null),

  getFileType: (state: State) => state.fileType,

  getFileTypes: (state: State) => state.fileTypes,

  getFileTypesByEditor: (state: State) => (editor: number) =>
    state.fileTypes?.filter(type => type.attachment_editor.includes(editor)) ||
    [],

  getFileTypeById: (state: State) => (id: number) =>
    state.fileTypes.find(type => type.id === id) || {},

  getHolidays: (state: State) => state.holidays,

  getDashboardInfo: (state: State) => state.dashboardInfo,

  getDashboardProductivity: (state: State) => state.dashboardProductivity,

  getEntityDashboardInfo: (state: State) => {
    const entities = state.dashboardCapacities.capacities
      ? state.dashboardCapacities.capacities.map(item => ({
          id: item.capacity?.entityId,
          name: `${item.capacity?.entity.abbreviation}/${
            item.capacity?.abbreviation.includes("/")
              ? item.capacity?.abbreviation.split("/")[1]
              : item.capacity?.abbreviation
          }`,
          count: item.count
        }))
      : [];
    entities.sort((prev, next) => next.count - prev.count);
    return entities.slice(0, 5);
  },

  getDashboardSubject: (state: State) => state.dashboardSubject,

  getDueDateList: (state: State, getters: Getters) =>
    state.dueDateList.map(process => ({
      ...process,
      origin: getters.getCapacityById(process.origin)
    })),

  getItensPage: (state: State) => state.itens_page,

  getProcessAnalise: (state: State) => state.processAnalise,

  getDashboardDueDate: (state: State) => state.dashboardDueDate,

  getDashboardSignature: (state: State) => state.dashboardSignature,

  getIndexer: (state: State) => state.indexer,

  getFilteredIndexer: (state: State) => (name: string) =>
    state.indexer.filter(item =>
      item.name.toLowerCase().includes(name.toLowerCase())
    ),

  getLegalReference: (state: State) =>
    state.legalReference.map(legalRef => ({
      ...legalRef,
      description_trunc: legalRef.description.replace(/ \(.+/g, "")
    })),

  getNews: (state: State) => state.news,

  getLaw: (state: State) => state.law,

  getDoc: (state: State) => state.doc,

  getLawGov: (state: State) => state.law_gov,

  getViewSector: (state: State) => state.viewSector,

  getListPart: (state: State) => state.listPart,

  getListCapacity: (state: State) => state.listCapacity,

  getListCapacities: (state: State, getters: Getters) => (
    filter?: string,
    limit = 0
  ) => {
    let finalList = [...state.capacities.filter(capacity => capacity.active)];
    if (typeof filter === "string" && filter.length) {
      const filterSpliter = filter.toLowerCase().split(" ");
      filterSpliter.forEach(filter => {
        const newArray: ICapacityPublic[] = [];
        finalList.forEach(capacity => {
          if (
            `${capacity.description} ${capacity.entity.abbreviation} ${
              capacity.abbreviation.includes("/")
                ? capacity.abbreviation.split("/")[1]
                : capacity.abbreviation
            }`
              .toLowerCase()
              .includes(filter)
          )
            newArray.push(capacity);
          finalList = newArray;
        });
      });
    }
    return (limit ? finalList.slice(0, limit) : finalList).map(
      getters.capacityStandardize
    );
  },

  getListCapacitiesWithProcess: (state: State, getters: Getters) => (
    filter?: string,
    limit = 0
  ) => {
    let finalList = state.allCapacities.filter(capacity =>
      state.listCapacitiesWithProcess.includes(capacity.id)
    );
    if (typeof filter === "string" && filter.length) {
      const filterSpliter = filter.toLowerCase().split(" ");
      filterSpliter.forEach(filter => {
        const newArray: ICapacityPublic[] = [];
        finalList.forEach(capacity => {
          if (
            `${capacity.description} ${capacity.entity.abbreviation} ${
              capacity.abbreviation.includes("/")
                ? capacity.abbreviation.split("/")[1]
                : capacity.abbreviation
            }`
              .toLowerCase()
              .includes(filter)
          )
            newArray.push(capacity);
          finalList = newArray;
        });
      });
    }
    return (limit ? finalList.slice(0, limit) : finalList).map(
      getters.capacityStandardize
    );
  },

  getListCapacityChildren: (state: State, getters: Getters) => (
    filter?: string
  ) => {
    let finalList = state.listCapacityChildren;

    if (typeof filter === "string" && filter.length) {
      const filterSpliter = filter.toLowerCase().split(" ");
      filterSpliter.forEach(filter => {
        const newArray: ICapacityPublic[] = [];
        finalList.forEach(capacity => {
          if (
            `${capacity.description} ${capacity.entity.abbreviation} ${
              capacity.abbreviation.includes("/")
                ? capacity.abbreviation.split("/")[1]
                : capacity.abbreviation
            }`
              .toLowerCase()
              .includes(filter)
          )
            newArray.push(capacity);
          finalList = newArray;
        });
      });
    }
    return finalList.map(getters.capacityStandardize);
  },

  capacityStandardize: () => (_capacity: ICapacityPublic) => ({
    ..._capacity,
    name: `${_capacity.entity.abbreviation}/${
      _capacity.abbreviation.includes("/")
        ? _capacity.abbreviation.split("/")[1]
        : _capacity.abbreviation
    } - ${_capacity.description}`.toUpperCase(),
    showCaseName: truncate(
      `${_capacity.entity.abbreviation}/${
        _capacity.abbreviation.includes("/")
          ? _capacity.abbreviation.split("/")[1]
          : _capacity.abbreviation
      } - ${_capacity.description}`.toUpperCase(),
      { length: 50 }
    ),
    abbreviationWithActiveStatus: capacityThreeAbbreviationFormatter(
      _capacity,
      false,
      true
    ),
    migrationFromName: capacityThreeAbbreviationFormatter(_capacity),
    migrationToName: capacityThreeAbbreviationFormatter(_capacity, true, false),
    capacity_id: _capacity.id,
    part_id: _capacity.entityId
  }),

  getVersion: (state: State) => ({
    list: state.versionList,
    count: state.versionCount
  }),

  getLastVersion: (state: State) => ({
    ...state.lastVersion,
    update_date:
      state.lastVersion?.description?.match(/(\d{1,2}\/\d{1,2}\/\d{4})/)?.[0] ||
      ""
  }),

  getSuiteNumbers: (state: State) => state.suiteNumbers,

  getPermission: (state: State) => ({
    list: state.permissionList,
    count: state.permissionCount
  }),

  getProfileKeywords: (state: State) => state.profileKeywords,

  getAllPermissionsKeywords: (state: State) => state.permissionsKeywords,

  getListHorizontalLogos: (state: State) => state.listHorizontalLogos,

  getListVerticalLogos: (state: State) => state.listVerticalLogos,

  getReportTypes: (state: State) => state.reportTypes,

  getManageUnityFilters: (state: State) => state.manageUnityFilters,

  getIsLoadingManageUnity: (state: State) => state.isLoadingManageUnity,

  getParentCapacity: (state: State) => state.parentCapacity
};

export default {
  StateControl: state,
  state,
  mutations,
  actions,
  getters
};
